import {
  SITE_ANALYTICS_CHART_PERIOD_OPTIONS,
  type SiteAnalyticsChartPeriodHours,
} from './posthogSiteActivity';

const SITE_ANALYTICS_PERIOD_KEY = 'engine-site-analytics-period-hours';
const DEFAULT_SITE_ANALYTICS_PERIOD_HOURS: SiteAnalyticsChartPeriodHours = 12;

function isValidPeriodHours(value: unknown): value is SiteAnalyticsChartPeriodHours {
  return (
    typeof value === 'number' &&
    SITE_ANALYTICS_CHART_PERIOD_OPTIONS.some((option) => option.hours === value)
  );
}

export function readSiteAnalyticsPeriodHours(): SiteAnalyticsChartPeriodHours {
  try {
    const raw = localStorage.getItem(SITE_ANALYTICS_PERIOD_KEY);
    if (raw != null) {
      const parsed = Number(raw);
      if (isValidPeriodHours(parsed)) return parsed;
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_SITE_ANALYTICS_PERIOD_HOURS;
}

export function persistSiteAnalyticsPeriodHours(hours: SiteAnalyticsChartPeriodHours): void {
  try {
    localStorage.setItem(SITE_ANALYTICS_PERIOD_KEY, String(hours));
  } catch {
    /* ignore */
  }
}

export function siteAnalyticsPeriodLabel(hours: SiteAnalyticsChartPeriodHours): string {
  return (
    SITE_ANALYTICS_CHART_PERIOD_OPTIONS.find((option) => option.hours === hours)?.label ??
    `Last ${hours} hours`
  );
}
